import { format } from "date-fns";
import { useFormik } from "formik";
import React from "react";
import { Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { fetchOrders } from "../../Services/OrderService";
import { fetchDeliveryTypeStore } from "../../../Services/CartService";
import { Collapse } from "react-collapse";

const orderStatuses = {
  pending: "Pending",
  confirmed: "Assigned Order",
  processing: "In process",
  picked_up: "Picked Up",
  delivered: "Delivered",
  out_for_delivery: "Out For Delivery",
  failed: "Payment Failed",
  ready_for_delivery: "Ready For Delivery",
  returned: "Returned",
  arrived: "Received at Hub",
  out_for_pickup: "Out for pickup",
  cancelled: "Cancelled",
  deferred: "Re-attempt",
  disputed: "Disputed",
};
const validationSchema = yup.object().shape({
  orderId: yup.string(),
  pickup_date: yup.date(),
  order_date: yup.date(),
  delivery_date: yup.date(),
  pickup_rider_name: yup.string(),
  delivery_rider_name: yup.string(),
  customer_name: yup.string(),
  payment_status: yup.string().oneOf(["paid", "unpaid"]),
  platform: yup.string().oneOf(["hub", "in-store"]),
  order_type: yup.string().oneOf(["regular", "express", "appointment"]),
  order_status: yup
    .string()
    .oneOf([
      "all",
      "pending",
      "arrived",
      "processing",
      "ready_for_delivery",
      "delivered",
    ]),
});

export const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [details, setDetails] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [showFilters, setShowFilters] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      orderId: "",
      pickup_date: "",
      order_date: "",
      delivery_date: "",
      pickup_rider_name: "",
      delivery_rider_name: "",
      customer_name: "",
      payment_status: "",
      platform: "",
      order_type: "",
      status: "all",
    },
    validationSchema,
    onSubmit: (v) => {
      const payload = { ...v };
      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          const x = payload[key];
          if (!x) delete payload[key];
        }
      }
      const p = serialize(payload);
      if (p && p !== "?") {
        getOrders(undefined, p);
      }
    },
    onReset: () => {
      formik.submitForm();
    },
  });

  const serialize = (obj) => {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p) && obj[p].trim()) {
        str.push(
          encodeURIComponent(p) + "=" + encodeURIComponent(obj[p].trim())
        );
      }
    return `${str.join("&")}`;
  };

  const getOrders = (url, params) => {
    setLoading(true);
    fetchOrders(url, params)
      .then((res) => {
        for (let i = 0; i < res?.data?.length; i++) {
          const row = res?.data?.[i];
          row.qq = 0;
          for (let j = 0; j < row?.details?.length; j++) {
            const item = row?.details?.[j];
            row.qq += item.quantity;
          }
        }
        return res;
      })
      .then(
        (res) => {
          setDetails(res);
          setLoading(false);
        },
        (err) => {
          console.warn(err);
          toast.error("Something went wrong while fetching orders.");
        }
      );
  };

  React.useEffect(() => {
    fetchDeliveryTypeStore(50, 1).then(
      (types) => {
        dispatch({ type: "setOrderTypes", payload: [...types].reverse() });
      },
      (err) => {
        console.warn(err, "err while fetching store delivery types...");
      }
    );
    formik.submitForm();
    formik.resetForm();
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({ type: "setDates", payload: null });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setOrderTypeId", payload: null });
    dispatch({ type: "setBookingType", payload: null });
    dispatch({ type: "setCustomerId", payload: null });
    dispatch({ type: "setSelfPick", payload: null });
    dispatch({ type: "setProcessing", payload: null });
    dispatch({ type: "setCoupon", payload: null });
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
  }, [dispatch]);

  return (
    <div className="container py-4" style={{ minHeight: "80vh" }}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-wrap align-items-center justify-content-between px-2">
                <h3 className="mb-0 ">
                  Orders{" "}
                  {details ? (
                    <span className="roles-count">{details?.total}</span>
                  ) : null}
                </h3>
                <div className="d-flex align-items-center flex-wrap gap-2">
                <span onClick={() => setShowFilters((e) => !e)}>
                  <i
                    className={`fa-solid fa-filter ${
                      showFilters ? "text-primary" : ""
                    }`}
                  ></i>
                </span>
                <button
                  className="btn btn-dark text-primary"
                  onClick={() => {
                    navigate("/store/orders/new");
                  }}
                >
                  + New Order
                </button>
                </div>
              </div>
              <hr style={{ borderColor: "#282828" }} />
              {Boolean(details) && !loading ? (
                <>
                  <Collapse isOpened={showFilters}>
                    <form
                      className="row align-items-end gy-2"
                      onSubmit={formik.handleSubmit}
                    >
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="orderId">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Order ID
                          </Form.Label>
                          <Form.Control
                            type="text"
                            size="sm"
                            name="orderId"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.orderId}
                            placeholder="Order ID"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="order_date">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Order Date
                          </Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            name="order_date"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.order_date}
                            placeholder="Order Date"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="pickup_date">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Pick Up
                          </Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            name="pickup_date"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.pickup_date}
                            placeholder="Pick Up"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="delivery_date">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Delivery Date
                          </Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            name="delivery_date"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.delivery_date}
                            placeholder="Delivery Date"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="pickup_rider_name">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Pickup Rider Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            size="sm"
                            name="pickup_rider_name"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.pickup_rider_name}
                            placeholder="Pickup Rider Name"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="delivery_rider_name">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Delivery Rider Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            size="sm"
                            name="delivery_rider_name"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.delivery_rider_name}
                            placeholder="Delivery Rider Name"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="customer_name">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Customer Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            size="sm"
                            name="customer_name"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.customer_name}
                            placeholder="Customer Name"
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="payment_status">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Payment Status
                          </Form.Label>
                          <Form.Select
                            type="text"
                            size="sm"
                            name="payment_status"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.payment_status}
                            placeholder="Payment Status"
                          >
                            <option value="">Select Payment Status</option>
                            <option value="paid">Paid</option>
                            <option value="unpaid">Unpaid</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="order_process">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Platform
                          </Form.Label>
                          <Form.Select
                            type="text"
                            size="sm"
                            name="order_process"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.order_process}
                            placeholder="Platform"
                          >
                            <option value="">Select Platform</option>
                            <option value="hub">Hub</option>
                            <option value="in-store">In-Store</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="order_type">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Order Type
                          </Form.Label>
                          <Form.Select
                            type="text"
                            size="sm"
                            name="order_type"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.order_type}
                            placeholder="Order Type"
                          >
                            <option value="">Select Order Type</option>
                            <option value="regular">Regular</option>
                            <option value="express">Express</option>
                            <option value="appointment">Come&Collect</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <Form.Group controlId="status">
                          <Form.Label style={{ fontSize: "0.875rem" }}>
                            Order Status
                          </Form.Label>
                          <Form.Select
                            type="text"
                            size="sm"
                            name="status"
                            style={{
                              padding: "0.375rem 0.75rem",
                              height: "auto",
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.status}
                            placeholder="Order Status"
                          >
                            <option value="">Select Order Status</option>
                            <option value="all">All</option>
                            <option value="pending">Pending</option>
                            <option value="arrived">Arrived</option>
                            <option value="processing">Processing</option>
                            <option value="ready_for_delivery">
                              Ready for Delivery
                            </option>
                            <option value="delivered">Delivered</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                      <div className="col-md-3 col-12">
                        <button
                          className="btn btn-dark text-primary"
                          // style={{ height: "44px" }}
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          Search
                        </button>
                        {formik.submitCount > 0 ? (
                          <button
                            className="btn btn-danger ms-1"
                            onClick={formik.handleReset}
                          >
                            {formik.submitCount}
                            Clear
                          </button>
                        ) : null}
                      </div>
                    </form>
                  </Collapse>
                  <hr
                    style={{
                      borderColor: "#282828",
                      marginBottom: !loading ? "0px" : "",
                    }}
                  />
                </>
              ) : null}
              {Boolean(details) && !loading ? (
                <>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="table-light">
                        <tr>
                          <th scope="col" style={{ minWidth: "90px" }}>
                            S.NO
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Order
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Date
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Rider Name
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Customer
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            Platform
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Pickup Date
                          </th>
                          <th scope="col" style={{ minWidth: "200px" }}>
                            Pickup Time Slot
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Delivery Date
                          </th>
                          <th scope="col" style={{ minWidth: "200px" }}>
                            Delivery Time Slot
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Payment Status
                          </th>
                          <th scope="col" style={{ minWidth: "220px" }}>
                            Cancel User
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            Total
                          </th>
                          <th scope="col" style={{ minWidth: "180px" }}>
                            Order Status
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Deferred At
                          </th>
                          <th scope="col" style={{ minWidth: "150px" }}>
                            Order Type
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            No of Bags
                          </th>
                          <th scope="col" style={{ minWidth: "130px" }}>
                            Quantity
                          </th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {details?.data?.map((order, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              <Link
                                className="text-primary cursor-pointer text-decoration-none"
                                to={`./view/${order.id}`}
                              >
                                {order.id}
                              </Link>
                            </td>
                            <td>{format(order.created_at, "do MMM yyyy")}</td>
                            <td>
                              {" "}
                              {order.delivery_rider
                                ? `${order.delivery_rider?.f_name} ${order.delivery_rider?.l_name}`
                                : order.pickup_rider
                                ? `${order.pickup_rider?.f_name} ${order.pickup_rider?.l_name}`
                                : "---"}
                            </td>
                            <td>
                              {order.customer
                                ? `${order.customer?.f_name} ${order.customer?.l_name}`
                                : "---"}
                            </td>
                            <td className="text-capitalize">
                              {/* {order.platform === 0
                                ? "App"
                                : order.platform === 1
                                ? "Web"
                                : order.platform === 2
                                ? "CRM"
                                : order.platform === 3
                                ? "WhatsApp"
                                : order.platform === 4
                                ? "In-Store"
                                : order.platform} */}
                              {order.order_process || "Hub"}
                            </td>
                            <td>{order.pickup_date}</td>
                            <td>{order.order_pickup_time_slot}</td>
                            <td>{order.delivery_date}</td>
                            <td>{order.order_delivery_time_slot}</td>
                            <td>
                              {order.payment_status === "paid" ? (
                                <span className="badge text-bg-success">
                                  Paid
                                </span>
                              ) : (
                                <span className="badge text-bg-danger">
                                  Unpaid
                                </span>
                              )}
                            </td>
                            <td>
                              {order.cancel_user
                                ? `${order.cancel_user.f_name} ${order.cancel_user.l_name} (Customer)`
                                : order.cancel_rider
                                ? `${order.cancel_rider.f_name} ${order.cancel_rider.l_name} (Rider)`
                                : "---"}
                            </td>
                            <td>Rs {order.order_amount?.toLocaleString()}</td>
                            <td>{orderStatuses[order.order_status]}</td>
                            <td>{order.deferred_at ?? "---"}</td>
                            <td>
                              {order.delivery_type?.title}{" "}
                              {order.delivery_type?.id != 1 &&
                              order.delivery_type?.id != 2
                                ? order.booking_type == 1
                                  ? "(Regular)"
                                  : "Express"
                                : null}
                            </td>
                            <td>{order.bags?.length?.toLocaleString()}</td>
                            <td>{order.qq?.toLocaleString()}</td>
                            <td className="action-td">
                              <Link
                                to={`/store/orders/view/${order.id}`}
                                // onClick={() => {
                                //   navigate();
                                // }}
                              >
                                <i className="fa-regular fa-eye"></i>
                              </Link>
                              <span
                                onClick={() => {
                                  if (
                                    ["delivered", "cancelled"].includes(
                                      order.order_status
                                    ) ||
                                    order.payment_status === "paid" ||
                                    order.order_process === "hub" ||
                                    order.order_process === ""
                                  )
                                    toast.error("This order cannot be edited.");
                                  else {
                                    navigate(`./edit/${order.id}`);
                                  }
                                }}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="w-100 d-flex align-items-center justify-content-between flex-wrap pt-3">
                    <nav aria-label="Page navigation example">
                      {details?.links?.length > 3 ? (
                        <ul className="pagination justify-content-end mb-0">
                          {details?.links?.map((link, index) => (
                            <li
                              className={`page-item ${
                                link.active ? "active" : ""
                              }`}
                              key={index}
                            >
                              <span
                                onClick={() => {
                                  if (!loading && link.url) {
                                    // getOrders(link.url);
                                    const pageParams = link.url.split("?")[1];
                                    const currentParams = serialize(formik.values);
                                    getOrders(undefined, `${currentParams}&${pageParams}`);
                                  }
                                }}
                                className="page-link cursor-pointer"
                                dangerouslySetInnerHTML={{
                                  __html: link.label,
                                }}
                              />
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </nav>

                    <span>
                      Showing {details?.from} to {details?.to} of{" "}
                      {details?.total}
                    </span>
                  </div>
                </>
              ) : (
                <div className="text-center w-100">
                  <Spinner variant="primary" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
